import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function TargetAudience() {
  const points = ['Te dijeron que tenés hígado graso y sentiste miedo porque no sabías qué significaba realmente.', 'Te preocupa que el problema avance en silencio mientras seguís comiendo como antes.', 'Buscaste en internet y terminaste más confundido, con listas de alimentos prohibidos y consejos que se contradicen.', 'Sentís culpa cada vez que comés pan, azúcar, frituras o algo dulce.', 'Querés hacer algo ahora, antes de que tus próximos análisis te den una mala noticia.', 'No querés vivir a dieta, pero tampoco querés seguir ignorando lo que está pasando en tu cuerpo.', 'Necesitás recetas reales para cuidar tu hígado sin cocinar doble y sin dejar de comer rico.'];
  return <section className="py-20 bg-stone-100" data-id="element-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-201">
        <div className="grid md:grid-cols-12 gap-12 items-center" data-id="element-202">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="md:col-span-5" data-id="element-203">
            <div className="rounded-2xl aspect-[4/5] relative bg-stone-50 flex items-center justify-center p-2" data-id="element-204">
              <img src="https://cdn.magicpatterns.com/uploads/fEXvWsPZfu6ythsGnVr8FS/Portada_chau_higado_graso_2B_bonus.png" alt="Chau Hígado Graso: guía principal más los bonos digitales (Lista de Compras Desinflamante, Menú 7 Días y Tabla de Reemplazos)" width={800} height={1000} loading="lazy" decoding="async" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-205" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="md:col-span-7" data-id="element-206">
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-8" data-id="element-207">
              Este producto es para vos si:
            </h2>

            <div className="space-y-4" data-id="element-208">
              {points.map((point, i) => <motion.div key={i} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.1
            }} className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm" data-id="element-209">
                  <CheckCircle2Icon className="w-6 h-6 text-brand-500 shrink-0 mt-0.5" data-id="element-210" />
                  <p className="text-stone-700 leading-relaxed" data-id="element-211">{point}</p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}